import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Face.css';
// import './ReactCrop.css';
import '../Mybumpie/ReactCrop.css';
import * as actions from '../Actions';
import Cookies from "js-cookie";
import { fetchInitialData2 } from "../../fetchData";
import Right from '../../right/Right';
import UploadFrame from '../common/UploadFrame';
import UploadImgOverlay from '../common/UploadImgOverlay';
import ShareMileOverlay from '../common/ShareMileOverlay';
import Service from '../../service/Service';

const service = new Service();

class UploadFace extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let ContestData = [];
        let ProductData = [];
        let cookieVAl = [];

        // if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
        //     initialData = window.__initialData__['initialData'];
        //     delete window.__initialData__;
        // } else {
        //     if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
        //         initialData = props.staticContext.initialData['initialData'];
        //     }
        // }
        // if (initialData) {
        //     if (initialData['data1'] && initialData['data1']['result']) {
        //         ContestData = initialData['data1']['result'];
        //     }
        //     if (initialData['data2'] && initialData['data2']['result']) {
        //         ProductData = initialData['data2'];
        //     }
        // }

        this.state = {
            initialData: initialData,
            ContestData: ContestData,
            ProductData: ProductData,
            childListData: global.userAry['childData']['UserChildList'],
            childName:Cookies.get('ChildName'),
            frameDate:Cookies.get('faceDate'),
            cookieVAl:Cookies.get(),
            isFaceUploaded:false,
            hashTag:'',
            selectedfile: '',
            imagePreviewUrl: '',
            croppedImageUrl: '',
            onErrorImg:'',
            contestId: '',
            tagProd: [],
            tagKids: [],
            insertIds: [],
            insertProdIds: [],
            Base64: '',
            cropx: '',
            cropy: '',
            cropwidth: '',
            cropheight: '',
            cropedImagePath: '',
            gender: '',
            userPhoto: '',
            frameId: Cookies.get('faceFrameId'),
            src: null,
            isMemorySelected: false,
            IsExpected: false,
            crop: {
                x: 0,
                y: 0,
                width: 200,
                height: 200,
            },

        };
        this.isJcropFilesLoaded = false;
    }
    // static initialAction(reqUrl, ftk, authData, uId, childData) {
    //     var header = {
    //         'Content-Type': 'application/json',
    //         'ftk': ftk,
    //         'uid': uId,
    //         'access-token': authData['access-token'],
    //         'user-agent': global.userAgent,
    //         'isdesktop': global.isdesktop
    //     }
    //     let obj1 = {
    //         url: global.api_url + "contest/getactivecontests",
    //         body: JSON.stringify({
    //             "type": "communitypostmemory"
    //         })
    //     };
    //     let obj2 = {
    //         url: global.api_url + "getproductfromhistory",
    //         body: JSON.stringify({
    //             'pageNo': 1,
    //             'pageSize': 15
    //         })
    //     };
    //     return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    // }
    componentDidMount() {
        console.log("cookie====>",this.state.cookieVAl);
        // this.getContestData();

       // var url = new URL(window.location.href);
        // var campaignFrame = url.searchParams.get("frameurl");
        // if (campaignFrame) {
        //     this.setState({ isCampaign: true });
        // }
        // window.addEventListener("beforeunload", this.onUnload);
        if (!global.ftk || !Cookies.get('faceFrameUrl') || Cookies.get('faceFrameUrl') == '') {
            this.props.history.push('/tools/capture-baby-moments');
        }else{
            // console.log("ProductData=============>", this.state.ProductData);
            // console.log("ProductData.length=============>",this.state.ProductData.result.length);
            // console.log("contestData=============>", this.state.ContestData);
            document.addEventListener("click", this.domClick);
            if (global.userAry['IsExpected']) {
                this.setState({
                    IsExpected: true
                });
            } else {
                this.setState({
                    IsExpected: false
                });
            }
            // if (navigator.onLine) {
            //     if (!this.state.ContestData || (this.state.ContestData && this.state.ContestData.length < 1)) {
            //         service.showLoader();
            //         this.getContestData();
            //     } else {
            //         localStorage.setItem('ContestData', JSON.stringify(this.state.ContestData));
            //     }
            //     if (!this.state.ProductData || (this.state.ProductData && this.state.ProductData.length < 1)) {
            //         service.showLoader();
            //         this.getProductData();
            //     } else {
            //         localStorage.setItem('ProductData', JSON.stringify(this.state.ProductData));
            //     }
            //     service.hideLoader();
            // } else {
            //     if (localStorage.getItem('ContestData')) {
            //         this.setState({
            //             ContestData: JSON.parse(localStorage.getItem('ContestData'))
            //         });
            //     }
            //     if (localStorage.getItem('ProductData')) {
            //         this.setState({
            //             ProductData: JSON.parse(localStorage.getItem('ProductData'))
            //         });
            //     }
            //     service.hideLoader();
            // }
            var hashtagurl = global.currentURL.split("?");
            var hashtg;
            if (hashtagurl[1]) {
                hashtg = hashtagurl[1].split("=");
                this.state.hashTag = hashtg[1]
            } else {
                this.state.hashTag = ""
            }
        }
    }
    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onUnload);
    }
    // getContestData() {
    //     console.log("getContestData");
    //     var postData = {
    //         "type": "communitypostmemory",
    //         "cookieVAl":this.state.cookieVAl
    //     }
    //     var url = global.api_ci_url + "Face/getActiveContestData";
    //     // var url= global.api_url + "contest/getactivecontests";
    //     service.postServiceCall(url, postData).then((json) => {
    //         console.log("getContestData=1111=============>", json['result']);
    //         if (json['result']) {
    //             this.setState({
    //                 ContestData: json['result'],
    //             }, () => { });
    //             localStorage.setItem('ContestData', JSON.stringify(json));
    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    // getProductData() {
    //     console.log("getProductData");
    //     var postData = {
    //         'pageNo': 1,
    //         'pageSize': 15
    //     }
    //     // var url= global.api_url + "getproductfromhistory";
    //     var url = global.api_ci_url + "MyBumpie/getProductData";
    //     service.postServiceCall(url, postData).then((json) => {
    //         console.log("getProductData===1111===========>", json['result']);
    //         if (json['result']) {
    //             this.setState({
    //                 ProductData: json['result'],
    //             }, () => { });
    //             localStorage.setItem('ProductData', JSON.stringify(json));
    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    // selected_contest(title, contestId) {
    //     console.log("selected_contest==========>", title, contestId);
    //     if (document.querySelector(".selected_option") != null) {
    //         document.querySelector(".selected_option").innerHTML = title;
    //     }
    //     this.state.contestId = contestId;
    //     document.querySelector(".options_overlay").style.display = "none";
    //     document.querySelector("#selconst").innerHTML = title;
    //     document.querySelector("#selconst").classList.add("R15_42");
    //     document.querySelector("#selconst").classList.remove("R15_9e");
    //     // document.querySelector(".shareicon").attr("data-icon-font", "A"),
    //     // document.querySelector("#sharepic").addClass("isChecked")
    // }
    // showOptions() {
    //     if (window.innerWidth < 767) {
    //         var e = window.innerWidth - document.querySelector(".option_list").offsetWidth;
    //         document.querySelector(".option_list").css = ("left", e / 2)
    //     }
    //     document.querySelector(".options_overlay").style.display = "block";
    // }
    // myProfile_status(e) {
    //     if (e.target.classList.contains('isChecked')) {
    //         e.target.classList.remove('isChecked');
    //         e.target.setAttribute('data-icon-font', "z");
    //     } else {
    //         e.target.value = 1;
    //         e.target.classList.add('isChecked');
    //         e.target.setAttribute('data-icon-font', "A");
    //     }
    // }
    // SlideTag(e) {
    //     if (this.state.insertIds.length < 1 && (document.querySelector(".slide-tag-active") == null || document.querySelector(".slide-tag-active"))) {
    //         if (document.querySelector(".slide-tag-active") != null) {
    //             for (var a = 0; a < document.querySelector(".slide-tag-active").length; a++) {
    //                 this.state.insertIds.push(document.querySelector(".slide-tag-active")[a].getAttribute("data-id"));
    //             }
    //         }
    //         if (e.target.getAttribute("data-id") == "1" && document.querySelector(".tagkids_1").classList.contains("slide-tag-active")) {
    //             document.querySelector(".tagkids_1").classList.remove("slide-tag-active");
    //             document.querySelector("#setmyselfval").value = "0";
    //         } else {
    //             document.querySelector(".tagkids_1").classList.remove("slide-tag-active");
    //             document.querySelector(".tagkids_1").classList.add("slide-tag-active");
    //             document.querySelector("#setmyselfval").value = "1";
    //         }
    //     }
    // }
    domClick(event) {
        console.log("domClick==================================>", event.target);
        if (event.target.id == "photodesc") {
            if(!event.target.nextSibling){
                return false;
            }
            console.log("domClick==================================>1");
            if (!event.target.nextSibling.classList.contains("focus-active")) {
                console.log("domClick==================================>2");
                event.target.nextSibling.classList.add("focus-active");
            } else if ("" == event.target.value && event.target.nextSibling.classList.contains("focus-active")) {
                console.log("domClick==================================>3");
                event.target.nextSibling.classList.remove("focus-active");
            }
        } else if (event.target.classList.contains('options_overlay') || event.target.classList.contains('alertMsg-overlay')) {
            event.target.style.display = "none";
        }else {
            return false;
        }
    }
    onChange(e) {
        if (navigator.onLine) {
            var fileObj = document.getElementById("face_upload").files[0];
            console.log(fileObj);
            if (fileObj.type.includes('image')) {
                console.log("image");
                if (fileObj.type && (fileObj.type.toLowerCase() == "image/jpg" || fileObj.type.toLowerCase() == "image/jpeg" || fileObj.type.toLowerCase() == "image/png") && fileObj.size < 8388608) {
                    this.setState({ isMemorySelected: true });
                    document.getElementsByClassName('file_upload_err')[0].style.display = "none";
                    document.getElementsByClassName('file_upload_err')[0].innerHTML = "";
                    if (this.isJcropFilesLoaded) {
                        actions.afterJcropFilesLoaded(fileObj);
                    } else {
                        var _this=this;
                        service.loadJcropFiles(_this).then(function () {
                            _this.isJcropFilesLoaded = true;
                            actions.afterJcropFilesLoaded(fileObj);
                        }).catch(function () {
                            _this.setState({ isMemorySelected: false });
                            document.getElementById("face_upload").value = null;
                            return false;
                        })
                    }
                } else {
                    document.getElementById("face_upload").value = null;
                    document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                    document.getElementsByClassName('file_upload_err')[0].style.visibility = "unset",
                    document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                    return false;
                }
            } else {
                document.getElementById("face_upload").value = null;
                document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                
                return false;
            }
        } else {
            document.getElementById("face_upload").value = null;
            service.showAlert("Please Check Internet Connection!!!");
        }
    }
    CancleButton() {
        window.scrollTo(0, 150),
        document.querySelector("#main_frame").setAttribute("src", Cookies.get("faceFrameUrl"));
        document.querySelector('.add_photo_lbl').style.display = "block";
        document.querySelector('.upload_photo_btns').style.display = "none";
        document.querySelector('.choose_photo_btns').style.display = "block";
    }
    UploadPhoto() {
        // e.preventDefault();
        var submit=true;

        if (!this.state.contestId && this.state.contestId == undefined) {
            this.state.contestId = 0;
        }
        for (var i = 0; i < this.state.childListData.length; i++) {
            if (this.state.childListData) {
                if (this.state.childListData.length > 1) {
                    if (this.state.childListData[i]['ChildId']==document.querySelector('.slide-tag-active').getAttribute('data-id')) {
                        if(this.state.childListData[i]['Gender']=='Boy') {
                            this.state.gender = 0;
                        } else {
                            this.state.gender = 1;
                        }
                        this.state.tagKids = [{
                            "childId": this.state.childListData[i]['ChildId'],
                            "childName": this.state.childListData[i]['ChildName'],
                            "dob": this.state.childListData[i]['DOB'],
                            "gender": this.state.childListData[i]['Gender'],
                            "childPic": this.state.childListData[i]['childPhoto']
                        }];
                    }
                }
            }
        }
        if (document.querySelector(".checkAll").classList.contains("isChecked")) {
            this.state.userPhoto = document.querySelector("#main_frame").src;
        } else {
            this.state.userPhoto = global.userAry['userPhoto'];
        }
        if (this.state.ProductData != '-1') {
            var comboval = 0;
            for (var i = 0; i < this.state.ProductData.length; i++) {
                if (this.state.ProductData['productId'] == this.state.insertProdIds[i]) {
                    comboval = this.state.ProductData['isCombo'];
                    this.state.tagProd = {
                        "productId": this.state.ProductData['productId'],
                        "isActive": this.state.ProductData['isActive'],
                        "productName": this.state.ProductData['productName'],
                        "isInStock": this.state.ProductData['isInStock'],
                        "catId": this.state.ProductData['catId'],
                        "subCatId": this.state.ProductData['subCatId'],
                        "brandId": this.state.ProductData['brandId'],
                        "isCombo": comboval
                    }
                }

            }
        }
        if (document.querySelector("#main_frame").src == Cookies.get("faceFrameUrl")){
            return document.getElementsByClassName('file_upload_err')[0].style.display = "inline-block",
                document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible",
                document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Upload Face Memory",
                submit = false,
                !1;
        }else{
            document.getElementsByClassName('file_upload_err')[0].style.display = "none",
            document.getElementsByClassName('file_upload_err')[0].style.visibility = "hidden",
            document.getElementsByClassName('file_upload_err')[0].innerHTML = "";
        }

        if (this.state.childListData.length > 0) {
            if (document.querySelector('.slide-tag-active').getAttribute('data-id') == "") {
                alert('You need to tag atleast one child in your post');
                document.querySelector('#tagIds').focus();
                submit = false;
                return false
            }
        }
        if (this.state.contestId.length > 0) {
            this.state.contestId = this.state.contestId
        } else {
            this.state.contestId = ""
        }
        if(submit){
            this.uploadFaceMemory();
        }
    }
    uploadFaceMemory() {
        // console.log("this.state.gender========>", this.state.gender);
        var postData = {
            "postType": "0",
            "desc": document.querySelector('#photodesc').value,
            "image": document.querySelector("#main_frame").src,
            "frameId": this.state.frameId,
            "childArr": global.userAry['childData']['UserChildList'],
            "tagKids": this.state.tagKids,
            "tagProd": this.state.tagProd,
            "contestId": this.state.contestId,
            "faceDate":this.state.frameDate,
            "userId": global.uID,
            "userName": global.userAry['userName'],
            "myself": document.querySelector("#setmyselfval").value,
            "setAsProfilePic": document.querySelector(".checkAll").classList.contains("isChecked"),
            "imageWidth": "450",
            "imageHeight": "450",
            "userPic": this.state.userPhoto,
            "userGender": this.state.gender
        }

        
        console.log("postData=======>", postData);
        // var url = global.api_url + "uploadmemory";
        var url = global.api_ci_url + "Face/uploadmemory";
        service.postServiceCall(url, postData).then((json) => {
            console.log("json===========>", json);
            if (json['result'] == "Success" && this.state.cropedImagePath != "") {
                console.log("API Responce in success image");
                Cookies.set("faceFrameUrl", '', 1);
                this.state.isFaceUploaded=true;
                document.getElementById("shareMileImg").src = this.state.cropedImagePath;
                document.getElementsByClassName("shareMile-overlay")[0].style.display = "block";
                if (window.innerWidth < 767) {
                    document.querySelector('.shareImg-container').style.left = (((window.innerWidth * 0.85) - 208) / 2) + "px";
                }
                var ischecked = document.getElementById('setpic').classList.contains("isChecked");
                if (json['result'] == "Success") {
                    if (ischecked == true) {
                        // var postData = {
                        //     "EmailAddress": global.ftk,
                        //     "firstname": global.userAry['childData']['UserMaster'].firstname,
                        //     "middlename": global.userAry['childData']['UserMaster'].middlename,
                        //     "lastname": global.userAry['childData']['UserMaster'].lastname,
                        //     "pmno": global.userAry['childData']['UserMaster'].mobileno,
                        //     "mobileno": global.userAry['childData']['UserMaster'].mobileno,
                        //     "DateOfBirth": global.userAry['childData']['UserMaster'].DateOfBirth,
                        //     "Sex": global.userAry['childData']['UserMaster'].Sex,
                        //     "MaritalStatus": global.userAry['childData']['UserMaster'].MaritalStatus,
                        //     "AD": global.userAry['childData']['UserMaster'].AD,
                        //     "WalletAmount": global.userAry['childData']['UserMaster'].WalletAmount,
                        //     "userPhoto": this.state.cropedImagePath,
                        // }
                        var gender=-1;
                        var Myrole;
                        if(global.userAry['childData']['UserMaster'].Sex == "Male"){
                            Myrole="Father";
                            gender=1;
                        }else if(global.userAry['childData']['UserMaster'].Sex == "Female"){
                            gender=0;
                            Myrole="Mother";
                        }
                        var postData = {
                            "fullname": global.userAry['childData']['UserMaster'].firstname,
                            "emailidverified": 1,
                            "mobilenoverified": 1,
                            "DateOfBirth": global.userAry['childData']['UserMaster'].DateOfBirth,
                            "gender": gender,
                            "myrole": Myrole,
                            "photopath": this.state.cropedImagePath,
                            "cookieVAl":this.state.cookieVAl
                        }

                        var url = global.api_ci_url + "Face/updateUserDetails";
                        // var url = global.fcapi_url + "updateuserprofileuae";
                        service.postServiceCall(url, postData).then((json) => {
                            console.log("API Responce UpdateUserInformation_app" + json)
                            if (json['UpdateUserInformation_appResult'] == "true") {
                                console.log(json['UpdateUserInformation_appResult']);
                            }
                        })
                    }
                    //alert("Picture Uploaded sucessfully")
                } else {
                    alert("Please wait");
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error("error", error);
            service.hideLoader();
        });
    }
    shareMileCloseButton() {
        document.querySelector('.shareMile-overlay').style.display = "none";
        this.props.history.push('/memories');
    }
    onUnload() {
        // if(this.state.isFaceUploaded){
        //     if (window.location.pathname.includes("uploadfaces") && !this.state.isFaceUploaded) {
        //         return "Do you really want to leave our brilliant application?"
        //     // }
        // }
    }
    // shareArticle(articleurl,shareoption) {
    //     console.log("shareoption=================>",shareoption,articleurl);
    //     var shareurl;
    //     if (!articleurl.includes('http')) {
    //         articleurl = 'https:' + articleurl;
    //     }
    //     let ary = document.getElementsByClassName('sharing-options');
    //     for (let i = 0; i < ary.length; i++) {
    //         ary[i].style.display = 'none';
    //     }
    //     // if(document.getElementsByClassName('share-overlay')){
    //     //     document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    //     // }
    //     if (shareoption === "facebook") {
    //         shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    //     } else if (shareoption === "twitter") {
    //         shareurl = 'https://twitter.com/share?url=';
    //     } else if (shareoption === "pintrest") {
    //         shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    //     } else if (shareoption === "whatsapp") {
    //         shareurl = 'whatsapp://send?text=';
    //     }
    //     var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    //     console.log("sharewindow " + shareoption + articleurl);
    //     if (sharewindow.focus) {
    //         sharewindow.focus();
    //     }
    //     return false;
    // }
    render() {
        return (
            <main className="main-container Face">
                <Helmet
                    title="Capture Your Baby Moments Everyday - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "Preserving baby memories is one of the best ways to save the precious moments of your baby so that you can’t miss out those lovely & funny moments of your child’s first year. With capture baby moments tool this is made easy. Picture today." }, { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby Moments </span>
                    </div>
                    <h1 className="B24_00">Capture "{String(this.state.childName).charAt(0).toUpperCase() + String(this.state.childName).slice(1)}" Memories</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="face_container upload_faces">
                            {/* <input type="hidden" name="tagIds" id="tagIds" value="<?=$childinfo[0]->childId;?>">
                                <input type="hidden" name="childlen" id="childlen" value="0">
                            <input type="hidden" name="contestid" id="contestid" value="<?php echo $contestId;?>"> */}
                            <input type="hidden" name="tagProdIds" id="tagProdIds" value="" />
                            <input type="hidden" id="setmyselfval" name="setmyselfval" value="0" />
                            <div className="photo_wrapper">
                                <div className="photo_frame">
                                    <img id="main_frame" src={Cookies.get("faceFrameUrl")} alt={Cookies.get("faceFrameUrl")} title={Cookies.get("faceFrameUrl")} />
                                    <label className="add_photo_lbl" htmlFor="face_upload" >
                                        <span className="R28_9e add_photo_uf">
                                            <span data-icon-font="x" className="icon"></span>
                                                Add Photo
                                            </span>
                                    </label>
                                    <input type="file" name="face_upload" id="face_upload" className="face_upload" onChange={(e) => this.onChange(e)} style={{ 'display': 'none' }} />
                                    <span className="M30_white face_date_container_uf">
                                        {this.state.frameDate}
                                    </span>
                                </div>
                                <div className="file_upload_err"></div>
                            </div>
                            {/* <div id="test_append"></div> */}
                            <div className="content_wrapper">
                            <UploadFrame eleRef={this} tool={"FB"}/>
                            </div>
                        </div>
                    </div>
                    </div>
                 
                    <UploadImgOverlay eleRef={this} tool={"FB"}/>
                {/* <!--shareMile popup starts-->  */}
                    <ShareMileOverlay eleRef={this} tool={"FB"}/>
                {/* <!--shareMile popup ends-->   */}
                <Right url={this.props.match.url} />
            </main>
        )

    }
}

export default UploadFace;



// WEBPACK FOOTER //
// src/shared/tools/Face/UploadFace.js